import * as actionTypes from "../actionTypes/actionTypes";

const initialState = {
  discounts: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  createDiscount: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  updateDiscount: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  deleteDiscount: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  renderDiscountsListData: [],
  transactionTypes: {
    data: [],
    isLoading: false,
    hasError: false,
  }  
};

export const discountReducer = (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.GET_DISCOUNTS:
      return {
        ...newState,
        discounts: { ...newState.discounts, isLoading: true, hasError: false },
      };
    case actionTypes.GET_DISCOUNTS_SUCCESS:
      return {
        ...newState,
        discounts: { ...newState.discounts, data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_DISCOUNTS_FAILURE:
      return {
        ...newState,
        discounts: { ...newState.discounts, data: action.payload, isLoading: false, hasError: true },
      };

    case actionTypes.CREATE_NEW_DISCOUNT:
      return {
        ...newState,
        createDiscount: { ...newState.createDiscount, isLoading: true, hasError: false },
      };
    case actionTypes.CREATE_NEW_DISCOUNT_SUCCESS:
      return {
        ...newState,
        createDiscount: { ...newState.createDiscount, data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.CREATE_NEW_DISCOUNT_FAILURE:
      return {
        ...newState,
        createDiscount: { ...newState.createDiscount, data: action.payload, isLoading: false, hasError: true },
      };

      case actionTypes.UPDATE_DISCOUNT:
      return {
        ...newState,
        updateDiscount: { ...newState.updateDiscount, isLoading: true, hasError: false },
      };
    case actionTypes.UPDATE_DISCOUNT_SUCCESS:
      return {
        ...newState,
        updateDiscount: { ...newState.updateDiscount, data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.UPDATE_DISCOUNT_FAILURE:
      return {
        ...newState,
        updateDiscount: { ...newState.updateDiscount, data: action.payload, isLoading: false, hasError: true },
      };

      case actionTypes.DELETE_DISCOUNT:
        return {
          ...newState,
          deleteDiscount: { ...newState.deleteDiscount, isLoading: true, hasError: false },
        };
      case actionTypes.DELETE_DISCOUNT_SUCCESS:
        return {
          ...newState,
          deleteDiscount: { ...newState.deleteDiscount, data: action.payload, isLoading: false, hasError: false },
        };
      case actionTypes.DELETE_DISCOUNT_FAILURE:
        return {
          ...newState,
          deleteDiscount: { ...newState.deleteDiscount, data: action.payload, isLoading: false, hasError: true },
        };

      case actionTypes.RENDER_DISCOUNT_LIST_DATA:
        return{
          ...newState,
          renderDiscountsListData:action.payload
        }

      case actionTypes.GET_TRANSACTION_TYPE:
        return {
          ...newState,
          transactionTypes: { ...newState.transactionTypes, isLoading: true, hasError: false },
        };
      case actionTypes.GET_TRANSACTION_TYPE_SUCCESS:
        return {
          ...newState,
          transactionTypes: { ...newState.transactionTypes, data: action.payload, isLoading: false, hasError: false },
        };
      case actionTypes.GET_TRANSACTION_TYPE_FAILURE:
        return {
          ...newState,
          transactionTypes: { ...newState.transactionTypes, data: action.payload, isLoading: false, hasError: true },
        };  

    default:
      return { ...newState };
  }
};
